__turbopack_context__.v({
  "brandBannerWrapper": "I5JjKq_brandBannerWrapper",
  "brandDescriptionWrapper": "I5JjKq_brandDescriptionWrapper",
  "brandInfoWrapper": "I5JjKq_brandInfoWrapper",
  "brandLogoWrapper": "I5JjKq_brandLogoWrapper",
  "breadcrumbsWrapper": "I5JjKq_breadcrumbsWrapper",
  "header": "I5JjKq_header",
  "infoDescription": "I5JjKq_infoDescription",
  "loaderWrapper": "I5JjKq_loaderWrapper",
  "mainBrandInfoWrapper": "I5JjKq_mainBrandInfoWrapper",
  "numberOfProducts": "I5JjKq_numberOfProducts",
  "sortingInputWrapper": "I5JjKq_sortingInputWrapper",
  "sortingLabel": "I5JjKq_sortingLabel",
  "title": "I5JjKq_title",
  "wrapper": "I5JjKq_wrapper",
});
